import React, { useEffect, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { apiJson } from '../../lib/api'
import { LiveBoard, type LiveDef } from './LiveBoard'
import { RealtimeBoard } from './RealtimeBoard'
import type { Library } from './model'

// A live dashboard alone in its own tab (§7l.7 "Open for a wallboard"): no
// rail, no library behind it, just the board and Full screen. V4 does this
// with a #live=<key> hash; here it is the /live/:key route, outside the
// Shell, so a packhouse TV shows nothing but the board.
export function WallboardPage() {
  const { key = '' } = useParams()
  const [params] = useSearchParams()
  const { user } = useAuth()
  const [def, setDef] = useState<LiveDef | null>(null)
  const [missing, setMissing] = useState<string | null>(null)
  const uid = user?.uid

  useEffect(() => {
    if (!user) return
    let live = true
    apiJson<Library>(user, '/api/reports')
      .then((lib) => {
        if (!live) return
        const d = lib.reports.find((r) => r.key === key)
        if (!d || !d.live || !d.built || !d.periods?.length) setMissing(d ? `${d.name} is not deployed yet.` : 'There is no live dashboard by that name.')
        else setDef({ key: d.key, name: d.name, periods: d.periods })
      })
      .catch((e) => live && setMissing(e?.message || 'Could not load the report library'))
    return () => {
      live = false
    }
  }, [key, uid])

  if (missing)
    return (
      <div style={{ padding: 40, textAlign: 'center', color: 'var(--dp-ink)', background: 'var(--dp-surface)', minHeight: '100vh' }}>
        <p style={{ fontSize: '1rem', fontWeight: 600 }}>{missing}</p>
        <Link to="/reports">Back to Reports</Link>
      </div>
    )
  if (!def) return <div style={{ minHeight: '100vh', background: '#0d1730' }} aria-busy="true" />
  if (def.key === 'realtime') return <RealtimeBoard def={def} wall />
  return <LiveBoard def={def} wall initialPeriod={params.get('period')} initialTeam={params.get('team')} />
}
